// Utilities for annotations

export function getAnnotationKey(a) {
    if (a.__uid) return a.__uid;
    const base = `${a.page}_${a.type}`;

    if (a.type === 'key_value') {
        const v = a.value?.bbox?.join('_') || 'no_val_bbox';
        return `${base}_${v}`;
    }

    if (a.type === 'entity' || a.type === 'summary_row') return `${base}_${a.bbox?.join('_')}`;
    if (a.type === 'table_row' && Array.isArray(a.columns)) {
        const coords = a.columns.map(col => col.bbox?.join('_')).join('|');
        return `${base}_${coords}`;
    }
    if (a.type === 'table' && Array.isArray(a.bbox)) return `${base}_${a.bbox.join('_')}`;
    return `${base}_fallback_${Math.random().toString(36).slice(2, 8)}`;
}

export function getTopY(a) {
    if (a?.bbox) return a.bbox[1];
    if (a?.value?.bbox) return a.value.bbox[1];   // value first
    if (a?.field?.bbox) return a.field.bbox[1];
    return Infinity;
}
